export class CodingUserSelected {
    element: string;
    value: string;
}
